import { DeviceModel } from '@models/device.model';


export const speakerBrandsStr: { [Property in DeviceModel.SpeakerBrands]: string } = {
  [DeviceModel.SpeakerBrands.TOA]: 'TOA',
  [DeviceModel.SpeakerBrands.Uniview]: 'Uniview',
  [DeviceModel.SpeakerBrands.SIP]: 'SIP client',
};
